import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	max-width: 1200px;
	margin: 0 auto;
	color: ${CSSVars.gray900};
	padding: 100px 20px;
	font-family: ${CSSVars.secondaryFont};

	&.dark {
		max-width: 100%;
		background-color: ${CSSVars.black};
		color: ${CSSVars.white};
		border-top: 1px solid rgba(255, 255, 255, 0.06);
		padding-left: 20px;
		padding-right: 20px;

		> h3,
		> div {
			max-width: 960px;
			margin-left: auto;
			margin-right: auto;
		}

		@media screen and (min-width: ${CSSVars.breakpointLG}) {
			padding-left: 40px;
			padding-right: 40px;
		}
	}

	h3 {
		font-size: ${CSSVars.fontSize2XL};
		text-align: center;
		margin-bottom: 50px;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			margin: 0 auto 30px;
		}
	}
`;

export const FaqItem = styled.div`
	border-bottom: 1px solid #e5e7eb;

	&.dark {
		border-bottom: 1px solid rgba(255, 255, 255, 0.08);
	}
`;

export const FaqButton = styled.button`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 20px 0;
	background: none;
	border: none;
	cursor: pointer;
	text-align: left;
	font-size: 18px;
	font-weight: 500;
	color: inherit;
	transition: opacity 0.2s ease;
	font-family: ${CSSVars.secondaryFont};

	&:hover {
		opacity: 0.8;
	}

	&:focus-visible {
		outline: 2px solid #6881E9;
		outline-offset: 2px;
		border-radius: 4px;
	}

	svg {
		flex-shrink: 0;
		margin-left: 16px;
	}

	span {
		flex: 1;
	}
`;

export const FaqContent = styled.div`
	max-height: 0;
	overflow: hidden;
	/* transition: max-height 0.3s ease; */
	font-size: 16px;
	line-height: 1.6;

	&.open {
		max-height: 2000px;
		padding-bottom: 20px;
	}

	a {
		color: ${CSSVars.blue500};
		&:hover {
			color: ${CSSVars.blue300};
			text-decoration: underline;
		}
	}

	ul {
		list-style: disc;
	}
	ol {
		list-style: decimal;
	}
	li {
		margin: 10px 0 0 20px;
	}
`;
